// extracted by mini-css-extract-plugin
export default {"divider":"Home_divider__FJzq6"};